import React, { useState, useEffect } from 'react';
import DemographicForm from '../Forms/DemographicForm';
import TripInfoForm from '../Forms/TripInfoForm';
import POITypeForm from '../Forms/POITypeForm';
import OtherPOICharacteristicsForm from '../Forms/OtherPOICharacteristicsForm';
import BreaksForm from '../Forms/BreaksForm';
import ThanksPage from '../Other_pages/ThanksPage';

import { fetchCountries, fetchCities, createUser } from '../api/api';

const FullApp = () => {
  const [currentPage, setCurrentPage] = useState('demographics');
  const [formData, setFormData] = useState('');
  const [countries, setCountries] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [userId, setUserId] = useState(0);

  useEffect(() => {
    const loadCountries = async () => {
      const countriesData = await fetchCountries();
      if (countriesData) setCountries(countriesData);
    };
    loadCountries();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const handleDemographicSubmit = (data) => {
    setFormData(data);
    setCurrentPage('poitypeform');
  };

  const handlePOITypeSubmit = (data) => {
    setFormData(data);
    setCurrentPage('otherpoicharacteristicsform');
  };

  const handleOtherPOICharacteristicsSubmit = (data) => {
    setFormData(data);
    setCurrentPage('breaksform');
  };

  const handleBreaksSubmit = async (data) => {
    setFormData(data);
    const citiesData = await fetchCities();
    if (citiesData) setCityOptions(citiesData);
    setCurrentPage('tinfo');
  };

  const handleTripInfoSubmit = async (data) => {
    setFormData(data);
    const userId = await createUser(data, true);
    setUserId(userId)
    setCurrentPage('thanks');
  };

  return (
    <>
      {currentPage === 'demographics' && <DemographicForm countries={countries} onNavigate={handleDemographicSubmit} />}
      {currentPage === 'poitypeform' && <POITypeForm formData={formData} onNavigate={handlePOITypeSubmit} />}
      {currentPage === 'otherpoicharacteristicsform' && <OtherPOICharacteristicsForm formData={formData} onNavigate={handleOtherPOICharacteristicsSubmit} />}
      {currentPage === 'breaksform' && <BreaksForm formData={formData} onNavigate={handleBreaksSubmit} />}
      {currentPage === 'tinfo' && <TripInfoForm formData={formData} cities={cityOptions} onNavigate={handleTripInfoSubmit} />}
      {currentPage === 'thanks' && <ThanksPage name={formData["name"]?.split(" ")[0]} />}
    </>
  );
};

export default FullApp;
